<template>
	<div ref="modal-main" :class="`base-modal layout-${layoutType}
        ${!showDesktop || forceMobile ? 'mobile' : ''} ${extraClasses}`">
        <div
            :class="`base-modal-con ${alignCenter ? 'center': ''} ${!hasCloseButton ? 'has-no-close-btn': ''}`"
            :style="heightCondition"
        >
            <div
                ref="modal-content"
                class="content"
                v-click-outside="closeBackDrop"
            >
                <a v-if="hasCloseButton" @click="closeModal" class="base-modal-close">
                    <i class="icon icon-close"></i>
                </a>
                <div class="base-modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>
        <!-- backdrop overlay -->
        <div class="backdrop"/>
	</div>
</template>

<script>
    import BaseModal from '@views/common/BaseModal/base_modal'

    export default {
    	mixins: [BaseModal],
        data () {
            return {
                elHeight: 0,
                resizeHeightObserver: null
            }
        },

        methods: {
            checkPopHeight() {
                this.elHeight = this.$refs['modal-content'].clientHeight
            }
        },

        computed: {
            heightCondition() {
                if(this.elHeight > this.windowHeight) {
                    return {
                        height: 'auto',
                    }
                }

                if(this.windowHeight > this.elHeight) {
                    return {
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                }
            }
        },

        mounted() {
            this.checkPopHeight()
            this.resizeHeightObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.elHeight = entry.target.clientHeight;
                }
            })

            this.resizeHeightObserver.observe(this.$refs['modal-content']);
        },

        beforeDestroy() {
            if(this.resizeHeightObserver) {
                this.resizeHeightObserver.disconnect();
                this.resizeHeightObserver = null;
            }
        }
    }
</script>

<style lang="scss" src="./base_modal.scss"></style>
